import React from 'react'
import SunDashboard from '@/components/sun/SunDashboard'

/** My Deliveries: the delivery schedule, with the rail beside it. */
function Dashboard(): React.JSX.Element {
  return (
    <div className="dashboard">
      <SunDashboard />
    </div>
  )
}

export default Dashboard
